// Rafraîchissement des leads par différence : après le premier chargement complet,
// on ne relit que les lignes dont `updated_at` a bougé (trigger set_updated_at en
// base, now() à l'insertion). Fonctions PURES, testées dans tests/leads-increment.test.js.

/** Marge de relecture : une ligne écrite pendant la lecture précédente n'est jamais manquée. */
export const MARGE_MS = 2 * 60_000;

const cle = (l) => `${l.item_id || ''}:${l.board_key || ''}`;

/** Les leads actuels, où chaque ligne relue remplace l'ancienne (même item_id et board). */
export function fusionneLeads(actuels, modifies) {
  if (!modifies.length) return actuels;
  const parCle = new Map(actuels.map((l) => [cle(l), l]));
  for (const l of modifies) if (l.item_id) parCle.set(cle(l), l);
  return [...parCle.values()];
}

/** Date à partir de laquelle relire : la plus récente modification connue, moins la marge. → ISO ou null */
export function relireDepuis(leads) {
  let max = '';
  for (const l of leads) if (l.updated_at && l.updated_at > max) max = l.updated_at;
  return max ? new Date(new Date(max).getTime() - MARGE_MS).toISOString() : null;
}
